<div class="page" id="page_gallery">
    <div class="container">

        <h2 class="section-title">NOSSO ESPAÇO</h2>
        <p></p>

        <ul *ngIf="model_pics" style="padding-bottom: 30px;">
            <li *ngFor="let p of model_pics">
                <a *ngIf="p.name != 'init'"> 
                    <img src="{{ 'http://haylie.bosswebapps.net/gallery/' + p.name }}" width="98%" />
                </a>
                
            </li>
        </ul>

        <br/><br/>


    </div>
</div>